import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram, FaLinkedin, FaGithub } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { useTranslation } from 'react-i18next'; // Import useTranslation

// Styled Components (Keep as is)
const FooterContainer = styled.footer`
  background: #222;
  color: white;
  padding: 2rem 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const FooterLinks = styled.ul`
  list-style: none;
  display: flex;
  gap: 1.5rem;
  margin: 1rem 0;
  padding: 0;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

const FooterLink = styled(Link)`
  color: white;
  text-decoration: none;
  font-size: 1rem;
  transition: color 0.3s;

  &:hover {
    color: #f4a261;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin: 1rem 0;
`;

const SocialIcon = styled.a`
  color: white;
  font-size: 1.5rem;
  transition: color 0.3s;

  &:hover {
    color: #f4a261;
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  opacity: 0.7;
`;

const Footer = () => {
  const { t } = useTranslation(); // Initialize translation hook

  return (
    <FooterContainer>
      {/* Navigation Links */}
      <FooterLinks>
        {/* Reuse navbar keys for consistency */}
        <li><FooterLink to="/">{t('navbar.home')}</FooterLink></li>
        <li><FooterLink to="/about">{t('navbar.about')}</FooterLink></li>
        <li><FooterLink to="/portfolio">{t('navbar.portfolio')}</FooterLink></li>
        <li><FooterLink to="/contact">{t('navbar.contact')}</FooterLink></li>
      </FooterLinks>

      {/* Social Media Icons (Links usually don't need translation) */}
      <SocialIcons>
        <SocialIcon href="https://www.facebook.com/profile.php?id=61575111968655" target="_blank" aria-label="Facebook"><FaFacebook /></SocialIcon>
        <SocialIcon href="https://twitter.com" target="_blank" aria-label="Twitter"><FaXTwitter /></SocialIcon>
        <SocialIcon href="https://instagram.com" target="_blank" aria-label="Instagram"><FaInstagram /></SocialIcon>
        <SocialIcon href="https://linkedin.com/company/imrane-labs" target="_blank" aria-label="LinkedIn"><FaLinkedin /></SocialIcon>
        <SocialIcon href="https://github.com" target="_blank" aria-label="Github"><FaGithub /></SocialIcon>
      </SocialIcons>

      {/* Copyright */}
      <Copyright>{t('footer.copyright', { year: new Date().getFullYear() })}</Copyright>
    </FooterContainer>
  );
};

export default Footer;